module.exports = __webpack_public_path__ + "img/leighton_b1.9adf1ff5.jpg";